import { mkConfig } from "export-to-csv";
/**
 * Gets the value or a default value if the provided value is undefined or null.
 * @param value - The value to check.
 * @returns The value or the default value.
 */
export const getValueOrDefault = (value?: null | number | string) =>
  value !== undefined && value !== null ? value : "-";

export const csvExportConfig = (fileName: string) => {
  return mkConfig({
    decimalSeparator: ".",
    fieldSeparator: ",",
    filename: fileName,
    quoteStrings: true,
    showTitle: false,
    useBom: true,
    useKeysAsHeaders: true,
    useTextFile: false,
  });
};
